import HeaderOriginal from "../components/HeaderOriginal/HeaderOriginal";
import StickyNavBar from "../components/Navigation/StickyNavBar";
import Footer from "../components/Footer";
import Container from "../components/Container";

const Commission = () => {
  const positions = [
    {
      m: 1,
      name: "حسين احمد بونيان",
      post: "الرئيس",
    },
    {
      m: 2,
      name: "	حسين حبيب آل خريده",
      post: "عضو",
    },
  ];

  const descriptions = [
    `وضع أسس ومعايت لحوكمة الجمعية ال تتعارض مع أحكام النظام أو الالئحة التنفيذية للنظام أو الالئحة األساسية للجمعية ومراقبة مدى فاعليتها وتعديلها عند الحاجة ورفعها للمجلس العتمادها.
`,
    `وضع أنظمة وضوابط للرقابة الداخلية واإلشراف عليها وإجراء مراجعة دورية للتحقق من فاعليتها وإصدار التوصيات بشأنها ورفعها للمجلس العتمادها.
`,
    `مراجعة اللوائح الاجرائيو والتنظيمية الالزمة التي  تضمن قيام الجمعية بأعمالها وتحقيق أهدافها ورفعها للمجلس العتمادها.`,
    `لتأكد من تقيد الجمعية (بما في ذلك فروعها ومراكزها) بأنظمة ولوائح الجمعية وكذلك السارية في المملكة بما يتضمن تلافي وقوع الجمعية في مخالفات نظامية والتوصية بشأنها ورفعها مجلس الادارة للاعتماد`,
    `مراجعة التقارير التي يعدها المدقق الداخىل ر والمراجع الخارجي والتوصية بشأنها ورفعها للمجلس العتمادها.`,
    `متابعة إنجازات التامج االجتماعية والتنموية والادارة التنفيذية والمشاريع االستثمارية وفقا لخططها الموضوعة والتأكد من كفاءتها وفاعليتها والتوصية بشأنها ورفعها للمجلس لالعتماد.`,
    `أي مهام أخرى تكلف بها من قبل المجلس ضمن اختصاصها.`,
  ];

  return (
    <>
      <HeaderOriginal></HeaderOriginal>
      <StickyNavBar></StickyNavBar>
      <Container>
        <div className="py-12 md:py-16 lg:py-24">
          <h1 className="font-bold text-lg md:text-xl lg:text-2xl mb-2 md:mb-4 text-[#21497C] text-center mb-8 md:mb-12">
            اللجان
          </h1>
          <div>
            <h4 className="text-[#408099] font-bold">اللجان الدائمة</h4>
            <p className="text-[#408099] font-bold">
              لجنة التدقيق والمراجعة الداخلية
            </p>
            <p className="text-[#408099] font-bold">الأعضاء </p>
            <div className="relative overflow-x-auto mt-4 mb-8 md:mt-8 md:mb-12">
              <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead className="text-base text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                  <tr>
                    <th scope="col" className="px-6 py-3">
                      م
                    </th>
                    <th scope="col" className="px-6 py-3">
                      الاسم
                    </th>
                    <th scope="col" className="px-6 py-3">
                      المنصب
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {positions.map(({ m, name, post }) => {
                    return (
                      <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                        <th
                          scope="row"
                          className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                        >
                          {m}
                        </th>
                        <td className="px-6 py-4">{name}</td>
                        <td className="px-6 py-4">{post}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div>
              <p className="text-[#408099] font-bold  mb-4 md:mb-8">
                مهام اللجنة
              </p>

              <ol>
                {descriptions.map((element) => (
                  <li className="list-decimal mr-8" key={element}>
                    {element}
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </div>
      </Container>
      <Footer></Footer>
    </>
  );
};

export default Commission;
